export const environment = {
    API_ENDPOINT: 'https://fa-greenslist-staging-ase-hea8dnexdtavexhp.australiasoutheast-01.azurewebsites.net/api',
    API_AUTH_CODE: 'gpZ4LFP7jI8XO2zE1Zn9CdOdP9BKhKfHZCd6HiedFQn7AzFuNpsLyA=='

}